import axios from 'axios'

const baseURL = import.meta.env.VITE_CASH_REGISTER_API_BASE_URL

const apiInstance = axios.create({
  baseURL,
  timeout: 5000
})

export default apiInstance
